import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ViewportLivecamNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.567 2.9835C7.7804 2.6072 6.9068 2.4 6 2.4V4.8C7.5652 4.8 8.8839 5.8051 9.3797 7.2H9.6C9.6 4.5489 11.7491 2.4 14.4 2.4V0C12.0032 0 9.8764 1.177 8.567 2.9835Z"
        fill={color}
      />
      <path
        d="M14.4 0V2.4C17.0509 2.4 19.2 4.5489 19.2 7.2H21.6C21.6 3.2299 18.3701 0 14.4 0Z"
        fill={color}
      />
      <path
        d="M0 8.40002H2.4C2.4 6.41172 4.0118 4.80002 6 4.80002V2.40002C2.6916 2.40002 0 5.09162 0 8.40002Z"
        fill={color}
      />
      <path
        d="M4.8 11.7797C3.405 11.2839 2.4 9.96519 2.4 8.40009H0C0 10.9246 1.606 13.1915 3.9962 14.0412C4.6661 14.2794 5.3403 14.4001 6 14.4001V12.0001C5.577 12.0001 5.1771 11.9137 4.8 11.7797Z"
        fill={color}
      />
      <path
        d="M19.2 7.20001C19.2 9.85091 17.0509 12 14.4 12V14.4C18.3701 14.4 21.6 11.1701 21.6 7.20001H19.2Z"
        fill={color}
      />
      <path
        d="M14.4 6C13.7373 6 13.2 6.5373 13.2 7.2C13.2 7.8627 13.7373 8.4 14.4 8.4C15.0627 8.4 15.6 7.8627 15.6 7.2C15.6 6.5373 15.0627 6 14.4 6Z"
        fill={color}
      />
      <path
        d="M5.99999 7.20001C5.33729 7.20001 4.79999 7.73731 4.79999 8.40001C4.79999 9.06271 5.33729 9.60001 5.99999 9.60001C6.66269 9.60001 7.19999 9.06271 7.19999 8.40001C7.19999 7.73731 6.66269 7.20001 5.99999 7.20001Z"
        fill={color}
      />
      <path
        d="M16.8 14.4V21.6H4.80002V14.4H16.8ZM16.8 12H4.80002C3.47452 12 2.40002 13.0745 2.40002 14.4V21.6C2.40002 22.9255 3.47452 24 4.80002 24H16.8C18.1255 24 19.2 22.9255 19.2 21.6V14.4C19.2 13.0745 18.1255 12 16.8 12Z"
        fill={color}
      />
      <path d="M2.4 15H0V18.6H2.4V15Z" fill={color} />
      <path
        d="M24 13.2C24 12.291 23.4864 11.4599 22.6733 11.0534C22.3338 10.8836 21.9661 10.8 21.6004 10.8C21.0903 10.8 20.5836 10.9625 20.1601 11.2801L17.7601 13.0801C17.1558 13.5333 16.8001 14.2447 16.8001 15.0001H19.2001L21.6001 13.2001V16.8H24.0001L24 13.2Z"
        fill={color}
      />
      <path
        d="M21.6 16.7999V20.3999L19.2 18.5999H16.8C16.8 19.3553 17.1557 20.0667 17.76 20.5199L20.16 22.3199C20.5835 22.6375 21.0903 22.7999 21.6003 22.7999C21.9661 22.7999 22.3336 22.7163 22.6732 22.5465C23.4863 22.14 23.9999 21.309 23.9999 20.3999V16.7999H21.6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ViewportLivecamNsk.displayName = 'ViewportLivecamNsk';
